<template>
  <div class="balance no-select cursor-pointer">
    <div class="balance--title">Баланс:</div>
    <div class="balance-show">
      <div class="item" v-if="balance.money && (balance.money > 0 || balance.points > 0)">
        <div class="money">{{balance.money}} рублей / </div>
        <div class="points">{{balance.points}} бонусов</div>
      </div>
      <div class="item" v-if="balance.money && balance.money == 0 && balance.points == 0">
        <div class="enroll">{{balance.enroll_package}} записей / </div>
        <div class="sms">{{balance.sms_package}} смс</div>
      </div>
      <div class="balance--preloader" v-if="showPreloader">
        <img :src="require('../assets/img/loader_6.svg')" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Balance",
  props: {
    websocketObserveOn: Boolean
  },
  computed: {
    ...mapState({
      balance: state => state.balance.balance,
    }),
    showPreloader(){
      return !this.balance.points && !this.balance.money;
    }
  },
};
</script>

<style scoped lang="less">
.balance{

  .balance-show{
    font-size: 13px;

    .item{
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      flex-direction: row;

      &>div{
        margin-right: 4px;
      }
    }

    .money, .points, .enroll, .sms{
      font-weight: 700;
    }
    .balance--preloader{

      img{
        width: 15px;
      }
    }
  }
}
</style>
